/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'FIRST_AID_KITS_ARE_NOT_SUFFICIENT_IN_NUMBER',
              'FIRST_AID_KITS_ARE_NOT_SUFFICIENTLY_MAINTAINED_NOT_FULLY_STOCKE',
              'FIRST_AID_KITS_ARE_NOT_CLEARLY_MARKED_AND_NOT_READILY_ACCESSIBL',
              'FACILITY_DOES_NOT_TRAIN_A_SUFFICIENT_NUMBER_OF_WORKERS_IN_FIRST',
              'FIRST_AID_TRAINING_RECORDS_ARE_NOT_RETAINED',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    is_the_fac_failing_to_comply_w_legal_reqs_for_any_of_the_follow: valueSchema,
  },
}
